/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 放电锁列表
export function listDischargeLock(params) {
    return request({
        url: 'dischargeLock/list.do?',
        method: 'post',
        data: params
    })
}

// 删除放电锁
export function deleteDischargeLock(params) {
    return request({
        url: 'dischargeLock/deleteById.do?',
        method: 'post',
        data: params
    })
}

// 批量保存放电锁
export function batchSaveDischargeLock(params) {
    return request({
        url: 'dischargeLock/batchSave.do?',
        method: 'post',
        data: params
    })
}

// 重置放电锁
export function saveDischargeLock(params) {
    return request({
        url: 'dischargeLock/save.do?',
        method: 'post',
        data: params
    })
}
